<template>
<div class="chapter">
<div class="inner_page">
<p class="ct" id="d12e97">Other Novels by Denise Hunter Include</p>
<p class="extc" id="d12e99"><i>The Convenient Groom</i><br/><i>Surrender Bay</i><br/><i>Finding Faith</i><br/><i>Saving Grace</i><br/><i>Mending Fences</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Hunt_9781595542595_epub_c4_r1.vue?33fef00a